import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';

export const CountryTelephoneFormat: Record<CountryIsoNumber, RegExp> = {
  [CountryIsoNumber.GreatBritain]: new RegExp(/^\d{10,11}$/),
  [CountryIsoNumber.Ireland]: new RegExp(/^\d{9,10}$/),
};
